import styled from 'styled-components';

const TagStyle = styled.div`
	--padTB: 18px;
	--padLR: var(--sp5x);

	user-select: none;

	.tag-wrapper {
		background-color: var(--gray100);
		border-radius: var(--sp7x);
		padding: var(--padTB) var(--padLR);
		transition: all var(--trTime) ease-out;
		cursor: pointer;

		&.active {
			background-color: var(--red1000);
			color: var(--white1000);
			cursor: default;
			pointer-events: none;
		}
	}

	@media (pointer: fine) {
		@media (hover: hover) {
			.tag-wrapper {
				&:not(.active):hover {
					background-color: var(--red1000);
					color: var(--white1000);
				}
			}
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--padTB: var(--sp2x);
		--padLR: var(--sp3x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--padTB: var(--sp2x);
		--padLR: var(--sp3x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--padTB: var(--sp2x);
		--padLR: var(--sp3x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--padTB: var(--sp2x);
		--padLR: var(--sp3x);
	}

	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--padTB: var(--sp2x);
		--padLR: var(--sp3x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--padTB: var(--sp2x);
		--padLR: var(--sp4x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--padTB: var(--sp2x);
		--padLR: var(--sp3x);
	}
`;

export default TagStyle;
